import { render, staticRenderFns } from "./Tccl2.vue?vue&type=template&id=0cbf99c4&scoped=true&"
import script from "./Tccl2.vue?vue&type=script&lang=js&"
export * from "./Tccl2.vue?vue&type=script&lang=js&"
import style0 from "./Tccl2.vue?vue&type=style&index=0&id=0cbf99c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf99c4",
  null
  
)

export default component.exports